class VerificationPopup extends HTMLElement {
    constructor() {
        super();
        this.showVerification();
    }

    connectedCallback() {
        this.addEventListeners();
    }

    /** Ad landings: ?age_gate=false hides the on-site gate (same cookie as confirming age). */
    staticAgeGateUrlBypass(urlParams) {
        return urlParams.get('age_gate') === 'false';
    }

    // Function to set a cookie
    setCookie(name, value, days) {
        const expires = days ? `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}` : '';
        document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
    }

    // Function to get a cookie
    getCookie(name) {
        return document.cookie.split('; ').reduce((r, c) => {
            const [key, value] = c.split('=');
            return key === name ? decodeURIComponent(value) : r;
        }, '');
    }

    // Function to delete a cookie
    deleteCookie(name) {
        this.setCookie(name, '', -1); // Setting the cookie with a past expiration date
    }

    addEventListeners() {
        const hideButtons = this.querySelectorAll('[hideverification]');
        const underLegalAgeButtons = this.querySelectorAll('[underLegalAge]');

        hideButtons.forEach(button =>
            button.addEventListener('click', this.hideVerification.bind(this))
        );

        underLegalAgeButtons.forEach(button =>
            button.addEventListener('click', this.underLegalAge.bind(this))
        );
    }

    hideVerification(event) {
        try {
            event.preventDefault();
            document.getElementById("verification-dialog").classList.add('hide_verification');
            document.querySelector("body").classList.remove('scroll-fixed');
            this.setCookie("vapour-age", "verified", 30); // Set cookie for 1 day
        } catch (err) {
            console.error(err, 'error');
            Utility._rollBar(err);
        }
    }

    showVerification() {
        try {
            const dialog = document.getElementById("verification-dialog");
            const body = document.querySelector("body");
            const urlParams = new URLSearchParams(window.location.search);
            const hadCookie = Boolean(this.getCookie("vapour-age"));
            const facebookBypass = urlParams.get('utm_source') === 'facebook';
            const queryBypass = this.staticAgeGateUrlBypass(urlParams);

            if (hadCookie || facebookBypass || queryBypass) {
                dialog.classList.add('d-none');
                body.classList.remove('scroll-fixed');
                if (queryBypass && !hadCookie) {
                    this.setCookie("vapour-age", "verified", 30);
                }
            } else {
                dialog.classList.remove('d-none');
                body.classList.add('scroll-fixed');
            }
        } catch (err) {
            console.error(err, 'error');
            Utility._rollBar(err);
        }
    }

    underLegalAge(event) {
        event.preventDefault();
        window.location.href = "https://google.com";
    }
}

document.addEventListener("DOMContentLoaded", () => {
    customElements.define("verification-form", VerificationPopup);
});
